import React, { useState, useEffect, useRef, useCallback, memo } from 'react';
import { MdExpandMore, MdExpandLess } from 'react-icons/md';
import styles from "./limit-number-of-lines.scss";


export const LimitNumberOfLines = memo(({ elem, maxLines = 5, width }: { elem: React.ReactNode[]; maxLines?: number; width?: number }) => {
  const [maxHeight, setMaxHeight] = useState<number | string>(24);
  const textRef = useRef(null);

  useEffect(() => {
    if (textRef.current) {
      showLess();
    }
  }, [maxLines]);

  const showMore = () => setMaxHeight('none');
  const showLess = useCallback(() => {
    const lineHeight = textRef.current ? window.getComputedStyle(textRef.current).lineHeight : '24';
    setMaxHeight(maxLines * (parseInt(lineHeight, 10) || 24));
  }, [maxLines, textRef.current]);

  const isTruncated = (textRef?.current?.scrollHeight > maxHeight);
  return (
    <div className={styles.wrapper} >
      <span ref={textRef} className={styles.text}
        style={{ maxHeight, minWidth: width ? `${width}px` : undefined }}>
        {elem.map((value) => value)}
      </span>
      <span className={styles.expandableLink}>
        <span>
          {isTruncated && <MdExpandMore onClick={showMore} />}
          {!isTruncated && maxHeight === 'none' && <MdExpandLess onClick={showLess} />}
        </span>
      </span>
    </div>
  );
});
